<template>
  <div class="head">
    <div class="max-image">
      <img src="../assets/images/new_image/banner.png" alt />
    </div>
    <div class="head-select">
      <div class="head-selsct-content">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="首页" name="home"></el-tab-pane>
          <el-tab-pane label="学校场地" name="schoolSite"></el-tab-pane>
          <el-tab-pane label="智慧健身房" name="wisdomGym"></el-tab-pane>
          <el-tab-pane label="指导员驿站" name="politicalPost"></el-tab-pane>
          <el-tab-pane label="免费低收费健身场馆" name="freeVenue"></el-tab-pane>
          <el-tab-pane label="赛事活动" name="matchActivity"></el-tab-pane>
          <!-- <el-tab-pane label="新闻公告" name="newsNotice"></el-tab-pane> -->
          <el-tab-pane label="健身地图" name="fitnessMap"></el-tab-pane>
          <!-- <el-tab-pane label="健身地图" name="fitnessMapIndex"></el-tab-pane> -->
          <el-tab-pane label="常见问题" name="commonMessage"></el-tab-pane>
          <el-tab-pane label="联系我们" name="callMe"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "headc",
  data() {
    return {
      input:'',
      activeName:'home'
    };
  },
  methods: {
     handleClick(tab, event) {
      this.activeName = tab.name;
      this.$router.push({ path: tab.name });
    },
  },
  created(){
    // console.log(this.$route.path)
  },
  watch:{
    '$route.path':function(){
      // console.log(this.$route.path)
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      if(this.$route.path!='/classDetail'){
        localStorage.removeItem('classId')
      }
      // console.log(this.$route.path)
      if(this.$route.path =='/home'){
          this.activeName = 'home'
      }
      // if(this.$route.path =='/newsNotice'){
      //     this.activeName = 'newsNotice'
      // }
      // if(this.$route.path =='/sportsVenue'){
      //     this.activeName = 'sportsVenue'
      // }
      // if(this.$route.path =='/sportsVenueInfo'){
      //     this.activeName = 'sportsVenue'
      // }
      if(this.$route.path =='/commonMessage'||this.$route.query.types==1){
          this.activeName = 'commonMessage'
      }
      if(this.$route.path =='/callMe'){
          this.activeName = 'callMe'
      }
      // if(this.$route.path =='/newsDetails'){
      //     this.activeName = 'newsNotice'
      // }
      if(this.$route.path =='/messageDetails'){
          this.activeName = 'commonMessage'
      }
      if(this.$route.path =='/schoolSite'||this.$route.query.type==0){
          this.activeName = 'schoolSite'
      }
      if(this.$route.path =='/wisdomGym'||this.$route.query.type==1){
          this.activeName = 'wisdomGym'
      }
      if(this.$route.path =='/politicalPost'||this.$route.path=='/classDetail'){
          this.activeName = 'politicalPost'
      }
      if(this.$route.path =='/freeVenue'||this.$route.query.type==3){
          this.activeName = 'freeVenue'
      }
      if(this.$route.path =='/fitnessMap'){
          this.activeName = 'fitnessMap'
      }
      if(this.$route.path =='/matchActivity'||this.$route.path=='/matchDetail'){
          this.activeName = 'matchActivity'
      }
      // if(this.$route.path =='/fitnessMapIndex'){
      //     this.activeName = 'fitnessMapIndex'
      // }
      if(this.$route.path =='/fitnessMap'){
          this.activeName = 'fitnessMap'
      }
      
    }
  }
};
</script>

<style scoped lang='less'>
.head {
  width: 100%;
  .max-image {
    width: 100%;
    img {
      width: 100%;
      display: block;
    }
  }
  .head-select {
    margin: 0;
    height: 60px;
    width: 100%;
    background:#2F89EB;
    // opacity: 0.1;
    .head-selsct-content {
      margin: 0 auto;
      width: 1198px;
      height: 100%;
      /deep/.el-tabs__item.is-active{
        // color: #666!important
        // background-color: rgba(255, 255, 255, 0.35);
        background:linear-gradient(to top,rgba(255, 255, 255, 0.35),#2F89EB);
      }

      /deep/.is-active::before{
        content: '';
        position: absolute;
        z-index: 1;
        bottom: 1px;
        left: 0;
        width: 100%;
        height: 6px;
        background: #fff;
        
      }
      // /deep/.el-tabs__nav ,.is-top{
      //   // transform: translateX(50%)!important
      // }
      /deep/.el-tabs__item{
        color: #fff;
        // width: 152px;
        padding: 0 22px;
        margin-right: 8px !important;
        text-align: center;
        font-size: 16px;
        height: 60px;
        line-height: 60px;
      }
      /deep/.el-tabs__nav-wrap::after{
        height: 0px;
      }
      /deep/.el-tabs ,.el-tabs--top{
          height: 100%;
          .el-tabs__header, .is-top{
            margin: 0;
            .el-tabs__nav-scroll{
              line-height: 60px;
              height: 60px;
              color: #fff!important;
            }
          }
        }

      .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover{
        background:rgba(34,164,230,1);
      }
      .el-menu{
        background-color: #25B1F7;
      }
      .head-selsct-content-left{
        display: inline-block;

      }
      .el-menu--horizontal>.el-menu-item{
        // margin-right: 100px;
        width: 152px;
        text-align: center;
        font-size: 18px;
        color: #fff;

      }
      .el-menu-item{
        padding: 0;
        height: 60px;
        line-height: 60px;
      }
      .el-menu.el-menu--horizontal{
        border: none;
      }
      .el-input{
        width:260px;
        height: 36px;
        vertical-align: top;
        margin-top:20px;
        // margin-left:190px;
        float: right;
        /deep/.el-input__inner{
        border-radius: 25px;
      }
      }
      /deep/.el-input__icon{
        height: 40px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headComponent.vue